import { get, put } from './requests'

const resourcePath = 'teams'

export function listTeams () {
  return get(resourcePath).then(response => response.teams)
}

export function updateTeamMembers (teamId, accountRolesIds) {
  return put(`${resourcePath}/${teamId}/members`, { team: { account_roles_ids: accountRolesIds } })
}
